export const getWebsiteLogo = (website: string | null, size = 18) => {
  if (website) {
    return `https://www.google.com/s2/favicons?sz=${size}&domain_url=${website}`;
  }
  return website;
};
